export const config = {
  defaultTenant: 'italent'
};
